<template>
  <div class="modal-overflow">
    <div class="row" style="width:100%;">
      <div class="col d-flex align-items-center" style="width:100%; flex-direction:column;">
        <label style="width:100%; text-align: center;"># Business Days History</label>
        <el-input-number v-model="solverParams.businessDaysAgo" :min="10" :max="400" :step="5"></el-input-number>
      </div>
      <div class="col">
        <div v-if="!solverParams.isSimulation">
          <label>Allow Reassignment of Manually Assigned Inspections</label>
          <el-checkbox v-model="solverParams.canReassignManualAssignments"></el-checkbox>
        </div>
        <div>
          <label>Assign Reinspections where No Previous Inspector Available</label>
          <el-checkbox v-model="solverParams.canAssignUnassignedReinspections"></el-checkbox>
        </div>
      </div>

    </div>
    <div class="row" style="width:100%;">
      <div class="col-4" style="width:100%;">
        <label>Eligibility Weight&nbsp;</label>
        <el-tooltip class="info-tooltip"
                    effect="dark"
                    placement="top-start">
          <div slot="content">Eligibilities are calculated based on how many inspections of a given type an inspector has recently completed,
            with more recent inspections being scored higher based on
            <a href='https://www.desmos.com/calculator/igd7flmiyq'>this sigmoid function.</a><br>
            The final Eligibility score is out of 1000 points, normalized to the highest Inspector's eligibility score per inspection type.
          </div>
          <img class="icon-help" src="static/img/icon-help.png"/>
        </el-tooltip>
        <el-slider v-model="solverParams.eligibilityWeight" :min="0" :max="10"></el-slider>
      </div>
      <div class="col-4" style="width:100%;">
        <label>Location Weight&nbsp;</label>
        <el-tooltip class="info-tooltip"
                    effect="dark"
                    placement="top">
          <div slot="content">The Location Score is calculated based on the number (weighted for recency based on
            <a href='https://www.desmos.com/calculator/igd7flmiyq'>this sigmoid function.</a><br>
            ) of inspections the assigned inspector has done in this City(5pts) Community(10pts) StreetName(20pts) StreetNum(30pts)

            The final Location score is out of 1000 points, normalized to the highest Inspector's location score for this inspections address.
          </div>
          <img class="icon-help" src="static/img/icon-help.png"/>
        </el-tooltip>
        <el-slider v-model="solverParams.locationWeight" :min="0" :max="10"></el-slider>
      </div>
      <div class="col-4" style="width:100%;">
        <label>Workload Weight&nbsp;</label>
        <el-tooltip class="info-tooltip"
                    effect="dark"
                    placement="top-end">
          <div slot="content">The workload distribution penalty is simply the squared number of inspections each inspector
            is assigned on this day. The penalty is minimized with an even workload across inspectors.
          </div>
          <img class="icon-help" src="static/img/icon-help.png"/>
        </el-tooltip>
        <el-slider v-model="solverParams.workloadWeight" :min="0" :max="1000"></el-slider>
      </div>
    </div>
  </div>
</template>

<script>
import {sync} from 'vuex-pathify'
import {InputNumber, Slider, Switch} from 'element-ui'

export default {
  components: {
    elInputNumber: InputNumber,
    elSlider: Slider,
    elSwitch: Switch,
  },
  computed: {
    solverParams: sync('inspectorRouting/solverParams'),
  }
}
</script>
